import { AUTH_TOKEN_CHANGED_EVENT } from './constants';

export const tokenChanged = token => {
  const event = new CustomEvent(AUTH_TOKEN_CHANGED_EVENT, {
    detail: { token },
  });
  window.dispatchEvent(event);
};

export const onTokenChange = listener => {
  window.addEventListener(AUTH_TOKEN_CHANGED_EVENT, listener);

  return () => {
    window.removeEventListener(AUTH_TOKEN_CHANGED_EVENT, listener);
  };
};
